// test1277
(1277 && 0);
